var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRelationship(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27131",
    "data-name": "Group 27131",
    transform: "translate(-75 -648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "users",
    d: "M3.534,11.07a1,1,0,1,1,.733,1.86A3.579,3.579,0,0,0,2,16.26V18a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V16.353a3.658,3.658,0,0,0-2.357-3.419,1,1,0,1,1,.713-1.868A5.658,5.658,0,0,1,14,16.353V18a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V16.26a5.579,5.579,0,0,1,3.533-5.19ZM7,1a4,4,0,0,1,4,4V7A4,4,0,0,1,3,7V5A4,4,0,0,1,7,1ZM7,3A2,2,0,0,0,5,5V7A2,2,0,0,0,9,7V5A2,2,0,0,0,7,3Zm9,17a1,1,0,0,1,0-2h1a1,1,0,0,0,1-1V15.162a3.387,3.387,0,0,0-2.316-3.213,1,1,0,1,1,.632-1.9A5.387,5.387,0,0,1,20,15.162V17a3,3,0,0,1-3,3ZM13,2a1,1,0,1,1,0-2,4,4,0,0,1,4,4V6a4,4,0,0,1-4,4,1,1,0,0,1,0-2,2,2,0,0,0,2-2V4A2,2,0,0,0,13,2Z",
    transform: "translate(81 654)",
    fill: "#adadad",
    strokeWidth: 0.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelationship);
export default __webpack_public_path__ + "static/media/Relationship.c6c68ab6.svg";
export { ForwardRef as ReactComponent };